import _ from 'lodash';
import {fields} from './fields.js';

const povijestBolesti = [
    {
        wrapper: 'row',
        className: 'row',
        fieldGroup: [
            _.merge({className: 'col-md-6', templateOptions: {disabled: true}}, fields.djelatnost),
            _.merge({className: 'col-md-6'}, fields.doktor)
        ]
    },
    {
        wrapper: 'fieldset',
        className: 'col-md-8',
        templateOptions: {
            label: 'Dijagnoza'
        },
        fieldGroup: [
            fields.dijagnoza,
            fields.dijagnoza_text
        ]
    },
    {
        wrapper: 'fieldset',
        className: 'col-md-8',
        fieldGroup: [
            fields.datum,
            _.merge({templateOptions: {disabled: true}}, fields.vrstaPosjete),
        ]
    },
    {
        wrapper: 'fieldset',
        templateOptions: {
            label: 'Trenutna posjeta'
        },
        className: 'col-md-12',
        fieldGroup: [
            _.merge({className: 'col-md-6'}, fields.napomena),
            {
                key: 'pregledi',
                type: 'feed',
                className: 'col-md-6'
            }

        ]
    }

];

export {povijestBolesti};



// WEBPACK FOOTER //
// ./app/components/pregled/form/povijestBolesti.js